export default __webpack_public_path__ + "static/media/partner.e4876c6e.svg";